import React, { useEffect, useState } from 'react'
import { useForm } from '../../../hooks/useForm';
import { useAxiosPost, useAxiosPost2 } from '../../../hooks/useAxiosPost';
import { useTranslation } from 'react-i18next';
import ReglasPopup from '../../popup/reglaspopup'

export default function ComentariosForm({ guid, titulo, onClose }) {

    const [t, i18n] = useTranslation("detail_blog");

    const [count, setCount] = React.useState(0);
    const [correo, setCorreo] = useState('');
    const [isReglasPopupOpen, setReglasPopupOpen] = useState(false);

    const [isValidEmail, setIsValidEmail] = useState(true);

    const onInputChangeCorreo = (e) => {
        setCorreo(e.target.value);
    };

    const i = 0;

    const [formSubmitted, setFormSubmitted] = useState(false)
    const [isSent, setIsSent] = useState(false);
    const { formState, onInputChange, Nombre, Procedencia, Comentario, Email, onResetForm } = useForm({
        Nombre: '',
        Procedencia: '',
        Comentario: '',
        Email: correo
    });

    const openReglasPopup = () => {
        setReglasPopupOpen(true);
    };

    const closeReglasPopup = () => {
        setReglasPopupOpen(false);
    };

    const handleEmailChange = (event) => {
        const { value } = event.target;
        setCorreo(value);

        // Validar el formato del correo electrónico
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsValidEmail(emailRegex.test(value));
    };


    const { data, isLoading, error } = useAxiosPost(
        formSubmitted ? '/comments/new' : null,
        {
            Nombre,
            Procedencia,
            Comentario,
            AceptTerminos: 1,
            Email: correo,
            id: guid
        }
    );

    const onFormSubmit = (event) => {
        event.preventDefault();

        if (Nombre.length <= 1) {
            alert((t('comments.v_nombre')));
            return;
        }

        if (correo.length <= 1) {
            alert((t('comments.v_email')));
            return;
        }

        if (Comentario.length <= 1) {
            alert((t('comments.v_comentario')));
            return;
        }

        if (isValidEmail) {
            console.log('Correo electrónico válido:', correo);
        } else {
            alert((t('comments.v_valido')));
            return;
        }

        setFormSubmitted(true);


    }

    useEffect(() => {

        if (formSubmitted && !isLoading && !error) {

            setIsSent(true);

            onResetForm();

            setCorreo('');

            setFormSubmitted(false);
        }

    }, [isLoading, error]);


    return (
        <>
            <div class="_ngcontent-ng-c782873536 _nghost-ng-c1716398032">
                <div role="dialog" aria-modal="true" aria-labelledby="opinion-modal-title" class="opinion-modal">
                    <section class="opinion-modal__panel">
                        <button
                            type="button"
                            aria-label="Cerrar ventana"
                            class="opinion-modal__close"
                            onClick={onClose}
                        >
                            ×
                        </button>
                        <header class="opinion-modal__header">
                            <h2 id="opinion-modal-title">{titulo}</h2>
                        </header>
                        <form
                            class="opinion-modal__form"
                            onSubmit={onFormSubmit}
                        >


                            {!isSent ? (
                                <>
                                    <h3 class="opinion-modal__form-title">{t("comments.title1")}</h3>
                                    <label for="opinion-name" class="opinion-modal__field">
                                        <span class="opinion-modal__field-label">{t("comments.name")}*</span>
                                        <input
                                            id="opinion-name"
                                            type="text"
                                            required
                                            class="opinion-modal__field-control"
                                            name="Nombre"
                                            value={Nombre}
                                            onChange={onInputChange}
                                        />
                                    </label>
                                    <label for="opinion-place" class="opinion-modal__field">
                                        <span class="opinion-modal__field-label">{t("comments.origin")}*</span>
                                        <input
                                            id="opinion-place"
                                            type="text"
                                            required
                                            class="opinion-modal__field-control"
                                            name="Procedencia"
                                            value={Procedencia}
                                            onChange={onInputChange}
                                        />
                                    </label>
                                    <label for="opinion-email" class="opinion-modal__field">
                                        <span class="opinion-modal__field-label">{t("comments.email")}*</span>
                                        <input
                                            id="opinion-email"
                                            type="email"
                                            required
                                            class="opinion-modal__field-control"
                                            value={correo}
                                            onChange={handleEmailChange}
                                        />
                                    </label>
                                    <label for="opinion-comment" class="opinion-modal__field opinion-modal__field--textarea">
                                        <span class="opinion-modal__field-label">{t("comments.v_comentarios")}*</span>
                                        <textarea
                                            id="opinion-comment"
                                            required
                                            rows="4"
                                            placeholder={t("comments.prueba")}
                                            class="opinion-modal__field-control opinion-modal__field-control--textarea"
                                            name="Comentario"
                                            value={Comentario}
                                            onChange={e => {
                                                onInputChange(e);
                                                setCount(e.target.value.length);
                                            }}
                                            maxLength={1500}
                                        />
                                    </label>
                                    <a onClick={openReglasPopup} ><div dangerouslySetInnerHTML={{ __html: (t('comments.show-rules')) }}></div></a>
                                    <button
                                        type="submit"
                                        class="opinion-modal__form-submit"
                                    >
                                        {isLoading ? "Enviando..." : "Enviar comentario"}
                                    </button>
                                </>
                            ) : (
                                <div className="write-me-modal__success">

                                    <img className='img-success-pal' src='/assets/img2026/palomita.svg' />

                                    <h2 className="write-me-modal__title">
                                        {i18n.language === "en"
                                            ? "Thank you for submitting your blog comment."
                                            : "Gracias por enviar tu comentario del blog."}
                                    </h2>



                                    <button
                                        type="button"
                                        className="btnSuscri subscribe-modal__submit typo-book-title"
                                        onClick={() => {

                                            setIsSent(false);

                                            onClose?.();

                                        }}
                                    >
                                        {
                                            i18n.language === "en"
                                                ? "Close"
                                                : "Cerrar"
                                        }
                                    </button>

                                </div>
                            )}
                        </form>
                    </section>
                </div>
            </div>

            {
                isReglasPopupOpen && (
                    <ReglasPopup
                        isOpen={isReglasPopupOpen}
                        onClose={closeReglasPopup}
                    />
                )
            }
        </>
    )
}
